/**
 *
 * @param {{ version: string }} state
 * @param {{ siteChromeVersion: Record<string, string> }} versionManifest
 * @returns {string} The legacy site chrome version string in the format "storeCode=templateVersion&..."
 * Generates a value suitable for the legacy Site Chrome Version cookie format.
 *
 * The passed `state.version` is used as the template version for all store codes.
 * The passed `versionManifest.siteChromeVersion` is used to determine the list of store codes.
 *
 * **Note: Any concerns relating to `current` or `previous` Site Chrome versions are ignored.**
 * @example
 * ```
 * au=13&com=13&de=13&dk=13&es=13&fr=13&it=13&nl=13&pl=13&roe=13&row=13&ru=13&se=13&us=13
 * ```
 */
export const getLegacySiteChromeVersion = (state, versionManifest) => {
  const templateVersion = state.version;

  const storeCodes = Object.keys(versionManifest.siteChromeVersion);

  const legacySiteChromeVersion = storeCodes
    .map(storeCode => `${storeCode}=${templateVersion}`)
    .join("&");

  return legacySiteChromeVersion;
};
